export const sidebarWidth = "205px";
export const topBarHeight = "70px";
export const sidebarWidthSmall = "64px";



// WEBPACK FOOTER //
// ./src/components/Common/Variables/CommonVariables.js